import { searchActionTypes } from "./search.types";

const INITIAL_STATE = {
    searchInput: '',
    loadingSearch: false,
    errorMessage: '',
    searchResult: [],
    searchResultSorted: {}
}

const searchReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case searchActionTypes.SET_SEARCH_INPUT:
            return {
                ...state,
                searchInput: action.payload,
            }

        case searchActionTypes.SET_SEARCH_RESULT:
            return {
                ...state,
                searchResult: action.payload
            }

        case searchActionTypes.SET_SEARCH_RESULT_SORTED:
            return {
                ...state,
                searchResultSorted: action.payload
            }

        case searchActionTypes.SEARCH_LOADING_START:
            return {
                ...state,
                loadingSearch: true
            }
        case searchActionTypes.SEARCH_LOADING_FINISH:
            return {
                ...state,
                loadingSearch: false
            }

        case searchActionTypes.SEARCH_LOADING_FAILURE:
            return {
                ...state,
                errorMessage: action.payload
            }
        default:
            return state;
    }
}

export default searchReducer;
